import styled, { css } from 'styled-components';
import { colors } from '@/globalStyles';
import store from '@/store';
import { SMARTPHONE, SUCCESS } from '@/constants';

export const ModalWrapperStyled = styled.div`
  width: 600px;
  outline: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${colors.white};
  border-radius: 10px;
  box-shadow: 2px 4px 16px 0 rgba(0, 0, 0, 0.25);
  padding: 30px;

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css``;
      }
      default: {
        return null;
      }
    }
  }}
`;

export const ModalBodyStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
`;

export const ModalFooterStyled = styled.div`
  ${props => {
    const { status } = props;

    switch (status) {
      case SUCCESS: {
        return css`
          display: grid;
          grid-template-columns: 1fr;
          grid-template-rows: 60px;
        `;
      }
      default: {
        return css`
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-gap: 16px;
          grid-template-rows: 60px;
        `;
      }
    }
  }}
`;

export const LoaderSpiner = styled.div`
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  display: flex;
  justify-content: center;
  align-items: center;
  animation: rotate 1.1s infinite linear;
`;

export const IconWrapperStyled = styled.div`
  text-align: center;
  margin-bottom: 30px;
`;

export const TitleStyled = styled.div`
  font-family: IBMPlexSans;
  font-weight: 700;
  font-size: 24px;
  line-height: 1;
  margin-bottom: 20px;
`;

export const DescriptionStyled = styled.div`
  font-family: IBMPlexSans;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.3;
  margin-bottom: 20px;

  a {
    color: ${colors.primary};
  }
`;
